module.exports = __webpack_public_path__ + "img/消费者累计核验.9ec7ac87.png";